import { render } from "./ChatBots.vue?vue&type=template&id=0109a940&scoped=true"
import script from "./ChatBots.vue?vue&type=script&lang=js"
export * from "./ChatBots.vue?vue&type=script&lang=js"

import "./ChatBots.vue?vue&type=style&index=0&id=0109a940&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0109a940"]])

export default __exports__